import {
  getDiscount,
  getItemCategory,
  getItemCategory2,
  normalizeBrand,
  resizeVtexImage,
} from '../../utils';
import { resolveItemId, resolveItemListName, saveViewedItem } from '../../utils/itemListAttribution';

export async function itemsFromPDP(context: Record<string, any>, event: string) {
  const { item, value, brand } = context;
  const resolvedListName = resolveItemListName({ event, item, itemListName: null });
  const resolvedItemId = resolveItemId(item);

  if (event === 'VIEW_ITEM') {
    saveViewedItem(resolvedItemId, resolvedListName);
  }

  return [
    {
      price: value || 0,
      quantity: 1,
      item_ref: item?.ref || item?.additionalProperty?.find((i: { name: string }) => i.name === "RefId").value || item?.productReference || null,
      item_brand: item.isNotFarm ? item?.item_brand : normalizeBrand(item?.brand.name) || normalizeBrand(brand) || null,
      item_name: item?.productName || item?.alternateName || null,
      item_category: getItemCategory(item) || null,
      item_variant: item?.name?.split("-")[0].trim() || null,
      item_category2: getItemCategory2(item) || item?.category?.split(">")[1]?.trim() || null,
      item_id: item?.productID || item?.productId || item?.item_group_id || null,
      discount: getDiscount(item) || null,

      // dito/insider params view_item
      item_sku: item?.sku || item?.productId || null,
      item_url: item?.url || item?.item_url || item?.link || null,
      image_url: resizeVtexImage(item?.image) || resizeVtexImage(item?.imageUrl) || null,
      seller_id: item?.seller || null,
      item_list_name: resolvedListName,
    },
  ];
}
